import { apiClient } from './http.api';

// WordPress API endpoints
const WP_API_BASE_URL = 'https://dig.watch/wp-json/dw/v2';

export const wpApi = {
  // Get events with children from WordPress
  getEventsWithChildren: async () => {
    try {
      const response = await fetch(`${WP_API_BASE_URL}/events_with_children`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching WordPress events:', error);
      throw error;
    }
  },

  // Get child events for a specific event
  getChildEvents: async (eventId) => {
    try {
      const response = await fetch(`${WP_API_BASE_URL}/child_events/${eventId}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const childEvents = await response.json();
      return childEvents;
    } catch (error) {
      console.error('Error fetching WordPress child events:', error);
      throw error;
    }
  },

  // Get event details by ID
  getEventById: async (eventId) => {
    try {
      const response = await fetch(`${WP_API_BASE_URL}/events_with_children`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const allEvents = await response.json();
      
      // Find the specific event
      const event = allEvents.find(ev => ev.ID === eventId);
      return event || null;
    } catch (error) {
      console.error('Error fetching WordPress event by ID:', error);
      throw error;
    }
  },

  // Get WordPress link for an event
  fetchWordpressLink: async (id) => {
    try {
      const response = await fetch(`https://dig.watch/wp-json/wp/v2/event/${id}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data?.link || null;
    } catch (error) {
      console.error('Error fetching WordPress link:', error);
      return null;
    }
  }
};

// Export individual functions for backward compatibility
export const {
  getEventsWithChildren,
  getChildEvents,
  getEventById,
  fetchWordpressLink
} = wpApi;